import React, { useEffect, useRef, useState } from "react";
import {
    MDBBtn,
    MDBIcon,
    MDBModalFooter
} from 'mdb-react-ui-kit';
import { useTranslation } from "react-i18next";
function ExportUsers() {

    const [selectedRegion, setSelectedRegion] = useState("IN");
    const { t, i18n } = useTranslation();

    return (
        <>
            <div>
                <MDBBtn  > <MDBIcon fas icon="upload" className="me-2" />Export Template</MDBBtn>
                {/* <p className="mt-3">Do you want to include Voicemail PINs in the Export?</p> */}
                {/* <MDBBtn className="ms-2"><MDBIcon fas icon="upload" className="me-2" />Export With Voicemail PINS</MDBBtn> */}
                <p className="mt-3">
                    <b> Note:</b> For SECURITY reasons, you must select whether you want to include Voicemail PINs in the export. You should use necessary security measures when exporting user Voicemail PINS</p>
            </div>
            <MDBModalFooter>
                <MDBBtn color='secondary'>
                    Cancel
                </MDBBtn>
                <MDBBtn>Export</MDBBtn>
            </MDBModalFooter>
        </>
    )
}
export default ExportUsers